let route =  [
  // 已下掉
  // {
  //   path: '/answer',
  //   name: 'answer',
  //   component: () => import('@/pages/routinePages/answer/index.vue'),
  //   meta: {
  //     title: '新手答题'
  //   }
  // },
  // 通用隐私服务协议模板
  {
    path: '/privacypolicy',
    name: 'privacypolicy',
    component: () => import('@/pages/routinePages/privacypolicy/index.vue'),
    meta: {
      title: '隐私协议'
    }
  },
  // 服务协议
  // {
  //   path: '/userAgreement',
  //   name: 'userAgreement',
  //   component: () => import('@/pages/routinePages/userAgreement/index.vue'),
  //   meta: {
  //     title: '用户协议'
  //   }
  // },
  // {
  //   path: '/winningRecord',
  //   name: 'winningRecord',
  //   component: () => import('@/pages/routinePages/winningRecord/index.vue'),
  //   meta: {
  //     title: '中奖记录'
  //   }
  // },
  {
    path: '/familyNotice',
    name: 'familyNotice',
    component: () => import('@/pages/routinePages/familyNotice/index.vue'),
    meta: {
      title: '家族公告'
    }
  },
  // 下架
  // {
  //   path: '/pkRecord',
  //   name: 'pkRecord',
  //   component: () => import('@/pages/routinePages/pkRecord/index.vue'),
  //   meta: {
  //     title: 'pk记录'
  //   }
  // },
  {
    path: '/rankingList',
    name: 'rankingList',
    component: () => import('@/pages/routinePages/rankingList/index.vue'),
    meta: {
      title: '排行榜'
    }
  },
  {
    path: '/cpRankList',
    name: 'cpRankList',
    component: () => import('@/pages/routinePages/cpRankList/index.vue'),
    meta: {
      title: '唯一cp排行榜'
    }
  },
  // {
  //   path: '/regisDetails',
  //   name: 'regisDetails',
  //   component: () => import('@/pages/routinePages/regisDetails/index.vue'),
  //   meta: {
  //     title: '报名详情'
  //   }
  // },
  // {
  //   path: '/dataStatistics',
  //   name: 'dataStatistics',
  //   component: () => import('@/pages/routinePages/dataStatistics/index.vue'),
  //   meta: {
  //     title: '数据统计'
  //   }
  // },
  {
    path: '/antiFraud',
    name: 'antiFraud',
    component: () => import('@/pages/routinePages/antiFraud/index.vue'),
    meta: {
      title: '反诈中心'
    }
  },
  {
    path: '/antiConvention',
    name: 'antiConvention',
    component: () => import('@/pages/routinePages/antiFraud/antiConvention.vue'),
    meta: {
      title: '反诈行为公约'
    }
  },
  {
    path: '/iosPay',
    name: 'iosPay',
    component: () => import('@/pages/routinePages/iosPay/index.vue'),
    meta: {
      title: '进圈充值'
    }
  },
  // {
  //   path: '/thirdPartyPay',
  //   name: 'thirdPartyPay',
  //   component: () => import('@/pages/routinePages/thirdPartyPay/index.vue'),
  //   meta: {
  //     title: '进圈充值'
  //   }
  // },
  {
    path: '/wxDraw',
    name: 'wxDraw',
    component: () => import('@/pages/routinePages/wxDraw/index.vue'),
    meta: {
      title: '绑定进圈ID，参与抽奖！'
    }
  },
  {
    path: '/unlockAnswer',
    name: 'unlockAnswer',
    component: () => import('@/pages/routinePages/unlockAnswer/index.vue'),
    meta: {
      title: '网络诈骗知识答题'
    }
  },
  {
    path: '/vueCase',
    name: 'vueCase',
    component: () => import('@/pages/vueCase/index.vue'),
    meta: {
      title: 'vue项目case'
    }
  },
  {
    path: '/parentCase',
    name: 'parentCase',
    component: () => import('@/pages/vueCase/parent.vue'),
    meta: {
      title: 'vue父组件'
    }
  },
  {
    path: '/store',
    name: 'store',
    component: () => import('@/pages/vueCase/store.vue'),
    meta: {
      title: 'store组件'
    }
  },
]

export {
  route
}
